import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  location: 'Bogotá, Colombia'
}, {
  name: 'Javier P.',
  location: 'CDMX, México'
}, {
  name: 'Alejandro R.',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Marcelo D.',
  location: 'Santiago, Chile'
}, {
  name: 'Gustavo F.',
  location: 'Lima, Perú'
}, {
  name: 'Daniel S.',
  location: 'Guadalajara, México'
}, {
  name: 'Pablo L.',
  location: 'Córdoba, Argentina'
}, {
  name: 'Fernando G.',
  location: 'Medellín, Colombia'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-[slideIn_0.5s_ease-out] max-w-[280px] md:max-w-[320px]" data-id="element-259">
      <div className="bg-white rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.2)] border-2 border-brand-secondary p-3 flex items-start gap-3 relative overflow-hidden" data-id="element-260">
        <div className="bg-brand-secondary p-2 rounded-full shrink-0 shadow-inner" data-id="element-261">
          <Zap className="w-5 h-5 text-brand-text" data-id="element-262" />
        </div>
        <div data-id="element-263">
          <p className="text-xs md:text-sm text-brand-text font-medium leading-tight mb-1" data-id="element-264">
            <span className="font-black" data-id="element-265">{currentPurchase.name}</span> de{' '}
            {currentPurchase.location} acaba de comprar el Master Electrotécnico
            ⚡
          </p>
          <p className="text-[10px] text-brand-primary font-black uppercase tracking-wider" data-id="element-266">
            Hace unos minutos
          </p>
        </div>
      </div>
      <style data-id="element-267">{`
        @keyframes slideIn {
          from { transform: translateX(-120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>;
}